import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import style from './style.scss'

type Props = {
  url: string
}

function AlreadyRegistered({ url }: Props) {
  return (
    <>
      <HeadlineTwo>You’re already registered!</HeadlineTwo>
      <p>
        Please{' '}
        <a className={style.link} href={url}>
          proceed to your OnRamp course
        </a>
        .
      </p>
    </>
  )
}

export default AlreadyRegistered
